import { DEFAULT_FORUM_LOGO_URL } from '../types/forum';
import { emptyForumAdminRow } from './forumAdmins';

export function createEmptyForumForm() {
  return {
    forum_id: '',
    name: '',
    category: '',
    url: '',
    topics_count: 0,
    posts_count: 0,
    members_count: 0,
    founded_year: new Date().getFullYear(),
    description: '',
    logo_url: DEFAULT_FORUM_LOGO_URL,
    is_active: true,
    software: '',
    is_sponsored: false,
    sponsored_until: '',
    topics_selector: '',
    posts_selector: '',
    members_selector: '',
    scrape_login_url: '',
    scrape_username: '',
    scrape_password: '',
    scrape_login_username_selector: '',
    scrape_login_password_selector: '',
    scrape_login_submit_selector: '',
    promo_section_url: '',
    forum_admins: [emptyForumAdminRow()],
    forum_controllers: [emptyForumAdminRow()],
  };
}

export function resolveForumLogoUrl(logoUrl: string | null | undefined): string {
  const trimmed = logoUrl?.trim();
  return trimmed || DEFAULT_FORUM_LOGO_URL;
}
